module.exports = __webpack_public_path__ + "img/26.e4895e47.png";